// extracted by mini-css-extract-plugin
module.exports = {"colors":"\"css/base/colors.css\"","grey-medium":"#5e5e5e","title":"_2eFZi7s undefined","outer":"_1D1QmCL"};